<template>
	<div>
		<div v-if="extra">
			<div class="flex justify-start align-middle">
				<b-input
					class="w-50 mr-5"
					placeholder="Nom de la liste"
					v-model="name"></b-input>
				<b-form-checkbox v-model="db"
					>sauvegarder en base</b-form-checkbox
				>
			</div>
			<div v-if="db">
				<p>Version :</p>
				<b-input v-model="version"></b-input>
			</div>
			<b-button @click="import_db(true)" variant="link" v-if="exist_db"
				>Importe la liste depuis la base de données</b-button
			>
			<br />
		</div>
		<div v-if="list.length === 0">
			<h4>Créer la liste</h4>

			<div v-show="text_list.length === 0">
				<b-form-file
					accept=".csv"
					@change="importFile"
					placeholder="Importer un fichier CSV"></b-form-file>
				<br />
				<br />
				<b-input
					placeholder="Colonne de la liste (première colonne par défaut)"
					v-model="column"></b-input>
				<br />
			</div>
			<div v-show="text_list.length === 0 && column.length === 0">
				<p>ou</p>
			</div>
			<!-- * inclure un format exemple -->
			<div class="" v-show="column.length === 0">
				<b-form-textarea
					id="textarea"
					v-model="text_list"
					placeholder="Coller la liste"
					rows="3"
					max-rows="10"></b-form-textarea>
			</div>

			<div v-show="text_list.length > 0">
				<b-button class="mt-2" @click="importText">Importer</b-button>
				<br />
			</div>
			<!-- <p>ou</p> -->
		</div>

		<draggable
			tag="ul"
			:list="list"
			class="mb-2 list-group"
			handle=".handle">
			<li
				class="list-group-item handle"
				v-for="(element, idx) in list"
				:key="element.id">
				<i class="fa fa-times close" @click="removeAt(idx)"></i>
				<vue-tags-input
					:placeholder="
						'ajouter ' +
						(element.words.length > 0
							? 'variante'
							: 'valeur initiale')
					"
					style="max-width: 100%; margin-right: 30px"
					obj_words
					v-model="element.word"
					:tags="element.words"
					:allow-edit-tags="true"
					@tags-changed="(newTags) => (element.words = newTags)" />
			</li>
		</draggable>

		<b-button @click="addList">Ajouter ligne</b-button>&nbsp;
		<b-button @click="() => toggleCollapses(!variant_show, false)"
			>Variants</b-button
		>&nbsp;
		<b-button @click="() => toggleCollapses(false, !filter_show)"
			>Filtres</b-button
		>&nbsp;
		<b-button @click="exportFile">Export</b-button>

		<b-collapse class="mt-2" v-model="variant_show" :id="'collapse-' + id">
			<h3>Gestion des variants</h3>

			<div :id="'jsoneditor-' + id"></div>

			<p>Test</p>
			<b-input
				@change="test_variant_result = set_variants([test_variant])"
				v-model="test_variant"></b-input>
			<p>Résultats</p>
			<div v-for="result in test_variant_result" :key="result">
				{{ result }}
			</div>
			<b-button @click="set_variant_list">Appliquer</b-button>
		</b-collapse>

		<b-collapse
			class="mt-2"
			v-model="filter_show"
			:id="'collapse-regex' + id">
			<h3>Filtres</h3>
			<b-input class="mb-2" v-model="test_regex"></b-input>
			<b-button @click="regex()">Test</b-button>&nbsp;
			<b-button @click="regex('keep')"
				>Garder valeurs correspondantes</b-button
			>&nbsp;
			<b-button @click="regex('delete')"
				>Supprimer valeurs correspondantes</b-button
			>&nbsp;
			<b-button @click="reset">Reset</b-button>
		</b-collapse>
	</div>
</template>

<script>
	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";
	import "../../public/js/ace-builds/src-min-noconflict/ace.js";

	import { JSONEditor } from "@json-editor/json-editor";

	const _ = require("underscore");
	const chardet = require("chardet");
	const json2csv = require("json2csv").parse;

	import * as CSV from "csv-string";
	import draggable from "vuedraggable";
	import uniqueId from "lodash.uniqueid";
	import VueTagsInput from "@johmun/vue-tags-input";
	import utils from "../services/utils.js";

	import element from "../services/element.js";

	export default {
		name: "listWords",
		components: {
			VueTagsInput,
			draggable,
		},
		props: {
			id: {
				default: 0,
			},
			extra: {
				default: true,
			},
			db_mode: {
				default: false,
			},
		},
		data() {
			return {
				ready: false,
				name: "",
				list: [],
				column: "",
				test_variant: "",
				test_variant_result: [],
				variant_parameters: [],
				test_regex: "",
				text_list: "",
				variant_show: false,
				filter_show: false,
				version: "",
				db: false,
				lists_db: {},
				lists_name_db: [],
				exist_db: false,
			};
		},
		watch: {
			name: {
				handler() {
					if (this.db_mode) {
						if (this.lists_db[this.name]) this.exist_db = true;
						else this.exist_db = false;
					}
					this.$emit("update", this.id, this.name, this.list, {
						variant_parameters: this.variant_parameters,
						db: this.db,
						version: this.version,
					});
				},
			},
			version: {
				handler() {
					this.$emit("update", this.id, this.name, this.list, {
						variant_parameters: this.variant_parameters,
						db: this.db,
						version: this.version,
					});
				},
			},
			db: {
				handler() {
					this.$emit("update", this.id, this.name, this.list, {
						variant_parameters: this.variant_parameters,
						db: this.db,
						version: this.version,
					});
				},
			},
			list: {
				deep: true,
				handler() {
					this.$emit("update", this.id, this.name, this.list, {
						variant_parameters: this.variant_parameters,
						db: this.db,
						version: this.version,
					});
				},
			},
			variant_parameters: {
				deep: true,
				handler() {
					this.$emit("update", this.id, this.name, this.list, {
						variant_parameters: this.variant_parameters,
						db: this.db,
						version: this.version,
					});
				},
			},
			variant_show: {
				handler() {
					this.$emit("update_variant_show", this.variant_show);
				},
			},
		},
		methods: {
			toggleCollapses(variant, filter) {
				this.variant_show = variant;
				this.filter_show = filter;
			},
			async load(data) {
				while (!this.ready) {
					await new Promise((resolve) => setTimeout(resolve, 100));
				}
				await this.setData(data.name, data.list, data.parameters);
			},
			async save() {
				if (this.db && this.db_mode)
					await element.save(
						this.name,
						this.version,
						this.list,
						"list"
					);

				return {
					name: this.name,
					list: this.list,
					parameters: {
						variant_parameters: this.variant_parameters,
						db: this.db,
						version: this.version,
					},
				};
			},
			async new() {
				await this.setData("", [], {
					variant_parameters: {},
				});
			},
			async import_db(force = false) {
				// console.log(this.lists_name_db)
				if (this.db_mode && this.lists_name_db.length == 0) {
					var lists = await element.getby_production(
						"list",
						this.search_lists_input || null
					);
					var lists = lists.element;
					this.lists_name_db = [];
					for (var i = 0; i < lists.length; i++) {
						this.lists_db[lists[i].libelle] = lists[i];
						this.lists_name_db.push(lists[i].libelle);
					}
					if (this.lists_db[this.name]) this.exist_db = true;
					else this.exist_db = false;
				}
				if (this.db || force == true) {
					var result = await element.load(
						this.name,
						this.lists_db[this.name].version,
						"list"
					);
					this.version = this.lists_db[this.name].version;
					this.list = result.list;
				}
			},
			regex(mode) {
				var re = new RegExp(this.test_regex, "gi");

				for (var i = 0; i < this.list.length; i++) {
					var arr = [];
					var list = [];
					for (var j = 0; j < this.list[i].words.length; j++) {
						var results = this.list[i].words[j].text.search(re);
						var elem = {
							text: this.list[i].words[j].text,
						};
						elem.style = "";
						if (results == -1) {
							if (!mode) elem.style = "background-color: red";
							if (mode != "keep") list.push(elem);
						} else if (results != -1) {
							if (!mode) elem.style = "background-color: green";
							if (mode != "delete") list.push(elem);
						}
					}
					this.list[i].words = list;
					if (this.list[i].words.length == 0) {
						this.list.splice(i, 1);
						i--;
					}
				}
			},
			reset() {
				for (var i = 0; i < this.list.length; i++) {
					var arr = [];
					var list = [];
					for (var j = 0; j < this.list[i].words.length; j++) {
						var elem = {
							text: this.list[i].words[j].text,
						};
						elem.style = "";
						list.push(elem);
					}
					this.list[i].words = list;
				}
			},
			async setData(name, list, parameters) {
				this.name = name;
				this.list = list;
				if (parameters) {
					this.variant_parameters = parameters.variant_parameters;
					this.db = parameters.db || false;
				}
				if (this.db_mode) await this.import_db();

				this.editor.setValue(this.variant_parameters);
			},
			setName(name) {
				//console.log("set name")
				this.name = name;
			},
			getName() {
				return this.name;
			},
			getList() {
				return this.list;
			},
			getVariants() {
				return this.variant_parameters;
			},
			setVariants(variant_parameters) {
				this.variant_parameters = variant_parameters;
			},
			removeAt(idx) {
				this.list.splice(idx, 1);
			},
			addList: function () {
				this.list.push({ id: uniqueId(""), words: [], word: "" });
			},
			importText() {
				var arr = this.text_list.split("\n");
				for (var i = 0; i < arr.length; i++) {
					arr[i] = { text: arr[i] };
				}
				this.createList(arr);
			},
			importArray: async function (results, column) {
				this.name = "liste";
				if (!column) column = Object.keys(results[0])[0];
				for (var i = 0; i < results.length; i++) {
					var words = results[i][column].split("|");
					var obj_words = [];
					for (var j = 0; j < words.length; j++) {
						if (words[j].trim())
							obj_words[j] = { text: words[j].trim() };
					}
					if (obj_words.length > 0)
						this.list.push({
							id: uniqueId(""),
							words: obj_words,
							word: "",
						});
				}
			},
			createList(results) {
				var self = this;

				var list = [];
				if (results.length > 0) {
					var column = self.column || Object.keys(results[0])[0];
					for (var i = 0; i < results.length; i++) {
						if (!list.includes(results[i][column].trim())) {
							list.push(results[i][column].trim());
						}
					}
					list.sort();
					for (var i = 0; i < list.length; i++) {
						var words = list[i].split("|");
						var obj_words = [];
						for (var j = 0; j < words.length; j++) {
							if (words[j].trim())
								obj_words[j] = { text: words[j].trim() };
						}
						if (obj_words.length > 0)
							self.list.push({
								id: uniqueId(""),
								words: obj_words,
								word: "",
							});
					}
				}
			},
			importFile: async function (event = null) {
				var self = this;

				var file = null;

				try {
					if (event.dataTransfer) file = event.dataTransfer.files[0];
					else file = event.target.files[0];
					this.name = file.name.split(".")[0];
					var str = await file.arrayBuffer();
					var encoding = chardet.detect(Buffer.from(str));
					var separator = CSV.detect(
						String.fromCharCode.apply(null, new Uint8Array(str))
					);
					if (separator != "," && separator != ";") separator = ",";
					this.$papa.parse(file, {
						encoding: encoding,
						delimiter: separator,
						header: true,
						skipEmptyLines: true,
						complete: function (results) {
							results = results.data;
							self.createList(results);
						},
					});
				} catch (error) {
					console.log("Invalid file ", error);
				}
			},
			exportFile() {
				var csv = [];
				for (var i = 0; i < this.list.length; i++) {
					var str = "";
					for (var j = 0; j < this.list[i].words.length; j++) {
						if (j != 0) str += " | ";
						str += this.list[i].words[j].text;
					}
					csv.push({ expressions: str });
				}

				//console.log(csv)

				var str_csv = json2csv(csv, {
					fields: ["expressions"],
					fieldNames: ["expressions"],
					del: ",",
					quote: '"',
				});

				//console.log(str_csv)

				utils.saveToFile(str_csv, this.name + ".csv");
			},
			set_variants(list_words) {
				for (var i = 0; i < this.variant_parameters.length; i++) {
					var l = list_words.length;
					for (var j = 0; j < l; j++) {
						list_words.push(
							list_words[j].replace(
								new RegExp(
									this.variant_parameters[i].value,
									"gi"
								),
								this.variant_parameters[i].value_replace
							)
						);
					}
				}

				list_words = _.uniq(list_words);

				return list_words;
			},
			set_variant_list() {
				for (var i = 0; i < this.list.length; i++) {
					var arr = [];
					for (var j = 0; j < this.list[i].words.length; j++) {
						arr.push(this.list[i].words[j].text);
					}
					arr = _.uniq(arr.concat(this.set_variants([arr[0]])));
					this.list[i].words = [];
					for (var j = 0; j < arr.length; j++) {
						this.list[i].words.push({ text: arr[j] });
					}
				}
			},
			async addValues(results, replace) {
				var self = this;

				if (replace) {
					this.list = [];
				}

				var elems = [];
				for (var i = 0; i < this.list.length; i++) {
					var arr = [];
					for (var j = 0; j < this.list[i].words.length; j++) {
						elems.push(this.list[i].words[j].text);
					}
				}

				var list = [];
				if (results.length > 0) {
					for (var i = 0; i < results.length; i++) {
						if (!list.includes(results[i].trim())) {
							list.push(results[i].trim());
						}
					}

					list.sort();

					for (var i = 0; i < list.length; i++) {
						var words = list[i].split("|");
						var obj_words = [];
						for (var j = 0; j < words.length; j++) {
							if (
								words[j].trim() &&
								!elems.includes(words[j].trim())
							)
								obj_words[j] = { text: words[j].trim() };
						}
						if (obj_words.length > 0)
							self.list.push({
								id: uniqueId(""),
								words: obj_words,
								word: "",
							});
					}
				}
			},
		},
		mounted: async function () {
			var self = this;

			//console.log("create list")

			var schema = {
				title: "Paramètres",
				type: "array",
				format: "table",
				items: {
					type: "object",
					title: "variant",
					properties: {
						value: {
							type: "string",
							title: "valeur",
						},
						value_replace: {
							type: "string",
							title: "valeur de remplacement",
						},
					},
				},
			};

			const jsoneditor = document.getElementById("jsoneditor-" + this.id);

			this.editor = new JSONEditor(jsoneditor, {
				schema: schema,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				object_background: "",
				prompt_before_delete: false,
			});

			await new Promise((resolve, reject) => {
				self.editor.on("ready", function () {
					self.ready = true;
					if (resolve) resolve();
				});
			});

			this.editor.on("change", function () {
				/*if (self.variant_parameters.length != 0 && self.editor.getValue().length != 0)
            {*/
				self.variant_parameters = self.editor.getValue();
				self.test_variant_result = self.set_variants([
					self.test_variant,
				]);
				//}
			});
		},
	};
</script>
&&
<style scoped></style>
